import React, { useState } from 'react';
import { Row, Col, Card, Button, Spinner, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { FormRow } from '../../../app/components/FormRow';
import { usePrinterService } from '../../../common/hooks/usePrinterService';
import { copyToClipboard } from '../../../common/copyToClipboard';

export const GetProtectedMemoryCard: React.FC = () => {
  const [jpkid, setJpkid] = useState('');
  const [documentData, setDocumentData] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const printerService = usePrinterService();

  const handleFetch = async (binary: boolean) => {
    setIsLoading(true);
    try {
      const result = await printerService.getDocumentFromProtectedMemory(
        Number(jpkid),
        binary,
      );
      setDocumentData(result.data);
      toast.success('Dokument pobrano pomyślnie');
    } catch (err) {
      const errorMsg =
        err instanceof Error ? err.message : 'Błąd pobierania dokumentu';
      console.error('Error fetching protected memory:', err);
      toast.error(errorMsg);
      setDocumentData('');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopy = async () => {
    if (documentData) {
      await copyToClipboard(documentData);
      toast.success('Skopiowano do schowka');
    }
  };

  return (
    <Row className="mb-4">
      <Col lg={8}>
        <Card>
          <Card.Header>
            <Card.Title className="mb-0">
              Pobierz dokument z pamięci chronionych drukarki
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <p className="text-muted">
              Pobierz dokument z pamięci chronionej drukarki, podając
              identyfikator dokumentu (jpkid).
            </p>

            <FormRow
              controlId="jpkid"
              label="Identyfikator (jpkid)"
              labelSize={3}
            >
              <Form.Control
                type="number"
                value={jpkid}
                onChange={e => setJpkid(e.target.value)}
                placeholder="Wpisz identyfikator dokumentu"
                disabled={isLoading}
                min="0"
              />
            </FormRow>

            <div className="d-flex gap-2 flex-wrap mt-3 mb-3">
              <Button
                variant="primary"
                onClick={() => handleFetch(false)}
                disabled={isLoading || !jpkid.trim()}
              >
                Pobierz dokument
              </Button>
              <Button
                variant="secondary"
                onClick={() => handleFetch(true)}
                disabled={isLoading || !jpkid.trim()}
              >
                Pobierz dokument (binarny)
              </Button>
              {isLoading && (
                <Button variant="outline-secondary" disabled>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Pobieranie...
                </Button>
              )}
            </div>

            {documentData && (
              <>
                <Form.Control
                  as="textarea"
                  rows={15}
                  value={documentData}
                  readOnly
                  className="bg-light font-monospace fs-6"
                />
                <div className="d-flex gap-2 flex-wrap mt-3">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={handleCopy}
                  >
                    Kopiuj do schowka
                  </Button>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
